module.exports = __webpack_public_path__ + "static/media/clock.797e841a.svg";